module.exports = __webpack_public_path__ + "img/Custom Product Builder.0d439d22.svg";